import React from 'react';
import { BrowserRouter } from 'react-router-dom';

import { env, AppContext } from '@wishmobile/mmrm-base';
import { RouterContainer } from '@wishmobile/mmrm-core';

import buttons from './assets/config/buttons';

const Router = () => {
  const initFunctions = () => {
    env.checkEnv();
  };

  return (
    <AppContext.Provider value={buttons}>
      <BrowserRouter>
        <RouterContainer initFunctions={initFunctions} />
      </BrowserRouter>
    </AppContext.Provider>
  );
};

export default Router;
